import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

function Carousel() {

    var carousel = $('.carousel');
    var carouselSlides    = carousel.children('div');
    if (carouselSlides.length > 1) {

        carousel.owlCarousel({   
            loop:true,
            items:1,
            dots:true,
            mouseDrag:false,
            autoplay:true,
            autoplayHoverPause:true,
            nav: true,
            lazyLoad:true,
            animateOut: 'fadeOut',
            margin:1,
            navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#FFF" fill-rule="evenodd" d="M7.041 14a1.89 1.89 0 0 0 1.385-.59c.765-.781.765-2.048 0-2.845l-3.49-3.567 3.49-3.567c.765-.781.765-2.049 0-2.845a1.947 1.947 0 0 0-2.784 0L.765 5.583a2.007 2.007 0 0 0-.577 1.415c0 .531.202 1.047.577 1.415l4.891 4.997c.39.398.895.59 1.385.59Z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#FFF" fill-rule="evenodd" d="M1.959 14a1.89 1.89 0 0 1-1.385-.59c-.765-.781-.765-2.048 0-2.845l3.49-3.567-3.49-3.567c-.765-.781-.765-2.049 0-2.845a1.947 1.947 0 0 1 2.784 0l4.877 4.997c.375.383.577.884.577 1.415s-.202 1.047-.577 1.415L3.344 13.41c-.39.398-.895.59-1.385.59Z"/></svg>']        
        });

    } else {

        carousel.owlCarousel({   
            loop:false,
            items:1,
            dots:false,
            mouseDrag:false,
            autoplay:false,
            autoplayHoverPause:false,
            nav: false,
            lazyLoad:true,
            navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#FFF" fill-rule="evenodd" d="M7.041 14a1.89 1.89 0 0 0 1.385-.59c.765-.781.765-2.048 0-2.845l-3.49-3.567 3.49-3.567c.765-.781.765-2.049 0-2.845a1.947 1.947 0 0 0-2.784 0L.765 5.583a2.007 2.007 0 0 0-.577 1.415c0 .531.202 1.047.577 1.415l4.891 4.997c.39.398.895.59 1.385.59Z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#FFF" fill-rule="evenodd" d="M1.959 14a1.89 1.89 0 0 1-1.385-.59c-.765-.781-.765-2.048 0-2.845l3.49-3.567-3.49-3.567c-.765-.781-.765-2.049 0-2.845a1.947 1.947 0 0 1 2.784 0l4.877 4.997c.375.383.577.884.577 1.415s-.202 1.047-.577 1.415L3.344 13.41c-.39.398-.895.59-1.385.59Z"/></svg>']
        });

    }

    //Go through each carousel on the page
    carousel.each(function() {
        //Find each set of dots in this carousel
        $(this).find('.owl-dot').each(function(index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', index + 1);
        });
        $(this).find('.owl-prev').each(function(index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', 'Previous slide button');
        });
        $(this).find('.owl-next').each(function(index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', 'Next slide button');
        });
    });

}

export default Carousel;




// WEBPACK FOOTER //
// ./src/js/app/components/Carousel.js